<h2 mat-dialog-title class="mb-3 text-center">{{ header + (this.playlist.Id ? backupMessage: '') }}</h2>
<div class="text-center mb-2">Are you sure?</div>
<mat-dialog-actions class="d-flex justify-content-between flex-nowrap m-0">
  <button mat-raised-button [mat-dialog-close]="false" mat-flat-button>Cancel</button>
  <button mat-raised-button [mat-dialog-close]="true" class="ml-4">Yes</button>
  <button *ngIf="this.playlist.Id" mat-raised-button class="backup-btn ml-4" (click)="onBackup()">Backup and Proceed</button>
</mat-dialog-actions>
